import React from 'react'
import PropTypes from 'prop-types'
import { Card, CardHeader, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons'

const useStyles = makeStyles((theme) => ({
  card: {
    marginBottom: theme.spacing(6),
  },
  title: {
    fontSize: theme.typography.pxToRem(16),
  },
  actions: {
    margin: 0,
    display: 'flex',
    alignSelf: 'center',
  },
  successIcon: {
    fontSize: theme.typography.pxToRem(18),
    color: theme.palette.success.light,
  },
  readonly: {
    opacity: 0.4,
  },
}))

const CompletedStep = ({ title, readonly }) => {
  const styles = useStyles()

  return (
    <Card
      className={styles.card}
      elevation={0}
    >
      <Box className={readonly ? styles.readonly : ''}>
        <CardHeader
          title={title}
          titleTypographyProps={{ variant: 'body1' }}
          action={
            <FontAwesomeIcon
              className={styles.successIcon}
              icon={faCircleCheck}
            />
          }
          classes={{
            action: styles.actions,
            title: styles.title,
          }}
        />
      </Box>
    </Card>
  )
}

CompletedStep.propTypes = {
  title: PropTypes.string.isRequired,
  readonly: PropTypes.bool,
}

export default CompletedStep
